/* Styled Components Starts here */

import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import styled from 'styled-components';
import { ToastType } from './types';
import { ToastIconColors } from '../../styles/colors';

// ✅ Divider Component
const Divider = styled.span`
  width: 1px;
  height: 24px;
  background-color: var(--gray-60);
  margin-right: var(--spacing-04);
`;

// ✅ Close Button Component
const CloseButton = styled.span`
  cursor: pointer;
  font-size: var(--font-size-lg);
`;

// ✅ Toast Icon Component
const ToastIcon = styled.span`
  font-size: var(--font-size-xl);
  margin-right: var(--spacing-02);
`;

const ToastDescription = styled.span`
  flex: 1;
  color: var(--white-100);
`;

const ToastWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const VariantIcon = styled(FontAwesomeIcon)<{ variant: ToastType }>`
  color: ${({ variant }) => {
    switch (variant) {
      case ToastType.Success:
        return ToastIconColors.Success;
      case ToastType.Error:
        return ToastIconColors.Error;
      case ToastType.Warning:
        return ToastIconColors.Warning;
      case ToastType.Info:
        return ToastIconColors.Info;
      default:
        return ToastIconColors.Info;
    }
  }};
`;

const CloseIcon = styled(FontAwesomeIcon)`
  color: var(--white-100);
`;

export {
  Divider,
  CloseButton,
  ToastIcon,
  ToastDescription,
  ToastWrapper,
  VariantIcon,
  CloseIcon,
};
